"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var prodSubscriptionPlans = [{
  name: 'Basic Package - Annual',
  price: '$200',
  id: 'plan_ES4uWIMB9qbTyv'
}, {
  name: 'Basic Package - Monthly',
  price: '$20',
  id: 'plan_ES4sRMulyYyxEH'
}, {
  name: 'Premium Package - Annual',
  price: '$470',
  id: 'plan_FIATZjlabkAsLp'
}, {
  name: 'Premium Package - Monthly',
  price: '$47',
  id: 'plan_FIARSW6TcxCilv'
}, {
  name: 'Advanced Package - Annual',
  price: 'Custom',
  id: 'I aint got one'
}, {
  name: 'Advanced Package - Monthly',
  price: 'Custom',
  id: 'I aint got one'
}];
var testSubscriptionPlans = [{
  name: 'Basic Package - Annual',
  price: '$200',
  id: 'AnnualPlanPlaceholder'
}, {
  name: 'Basic Package - Monthly',
  price: '$20',
  id: 'AnnualPlanPlaceholder'
}, {
  name: 'Premium Package - Annual',
  price: '$470',
  id: 'AnnualPlanPlaceholder'
}, {
  name: 'Premium Package - Monthly',
  price: '$47',
  id: 'AnnualPlanPlaceholder'
}, {
  name: 'Advanced Package - Annual',
  price: 'Custom',
  id: 'I aint got one'
}, {
  name: 'Advanced Package - Monthly',
  price: 'Custom',
  id: 'I aint got one'
}];
var planMode = process.env.STRIPE_PLAN_MODE || process.env.STORYBOOK_STRIPE_PLAN_MODE;
var subscriptionPlans = planMode === 'test' ? testSubscriptionPlans : prodSubscriptionPlans;
var _default = subscriptionPlans;
exports["default"] = _default;